// extracted by mini-css-extract-plugin
export default {"visuallyHiddenText":"hidden-h1_visuallyHiddenText__1RAq4"};